// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { CreateProcessChainRequestSchema, CreateProcessChainResponseSchema } from './create-process-chain.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
export const createProcessChainContract = {
    method: 'POST',
    path: '/api/v2/process-chains',
    description: 'Create a new process chain',
    requestSchema: CreateProcessChainRequestSchema,
    responseSchema: CreateProcessChainResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Parent chain not found'
        }
    }
};

//# sourceMappingURL=create-process-chain.contract.js.map